import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';

interface AgentDetailDialogProps {
  agentId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const AgentDetailDialog = ({ agentId, open, onOpenChange }: AgentDetailDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Agent Details</DialogTitle>
          <DialogDescription>
            Configure and manage your AI agent
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <p>Agent configuration panel will be implemented here.</p>
        </div>
      </DialogContent>
    </Dialog>
  );
};